import { VettingProvider } from './types';
import { globalGetService } from '@/utils/globalApiServices';

export const getVettingProviders = async () => {
  const response = await globalGetService('csp/evp');
  return (response?.ok ? response.data : []) as VettingProvider[];
};
